<div class="container">
    <ng-container *ngFor="let key of itemKeyapi">
        <div class="row justify-content-center">
            <div class="col-xl-4 col-lg-4 col-12 text-center">
                <div class="box-key text-start ">
                    <div class="col-12 mb-3">
                        <p>System</p>
                        <div class="box-key-api  input-icon-end m-action">
                            <input type="text" class="form-control" disabled [(ngModel)]="key.System_name">
                        </div>
                    </div>
                    <div class="col-12 mb-3">
                        <p>KEY User</p>
                        <div class="box-key-api  input-icon-end m-action">
                            <input type="text" class="form-control" disabled [(ngModel)]="key.Key_user">
                            <span class="material-symbols-outlined" (click)="copyText(keyUser)">
                                content_copy
                            </span>
                        </div>
                    </div>
                    <div class="col-12">
                        <p>KEY API</p>
                        <div class="box-key-api  input-icon-end m-action">
                            <input type="text" class="form-control" disabled [(ngModel)]="key.Key_api">
                            <span class="material-symbols-outlined" (click)="copyText(keyApi)">
                                content_copy
                            </span>
                        </div>
                    </div>
                    <div class="col-12">
                        <br>
                        <button class="btn btn-primary" (click)="changeKey(key)">
                            Change Key Api
                        </button>
                    </div>
                </div>
                <!-- <br>
            <button class="btn btn-primary btn-create-key" (click)="createKey()" *ngIf="!keyApi">
                สร้าง Key Api
            </button>
            <button class="btn btn-primary" *ngIf="keyApi" (click)="changeKey()">
                เปลี่ยน Key Api
            </button> -->
                <br><br>
                <hr>
            </div>
        </div>
        <br>
        <br>
    </ng-container>
</div>